import React from 'react';
import { InputTextUI, InputTextVAProps } from './InputText.Presenter';

export const InputTextContainer = React.memo(function InputTextContainer(props: InputTextVAProps) {
  return <InputTextUI {...props} />;
});
